import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { usePreferencesUI } from "@/context/PreferencesUIContext";
import { PreferencesPanel } from "./PreferencesPanel";

/** Overlay preferences — underlying page stays mounted for live updates. */
export function PreferencesSheet() {
  const { open, setOpen } = usePreferencesUI();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        side="right"
        className="glass-overlay w-[min(24rem,92vw)] border-border/60 p-0 sm:max-w-md"
      >
        <SheetHeader className="border-b border-border/60 px-5 py-4 text-left">
          <SheetTitle>Preferences</SheetTitle>
          <SheetDescription>
            Grouped settings apply immediately. Press / to search.
          </SheetDescription>
        </SheetHeader>
        <div className="px-5 py-4">
          <PreferencesPanel />
        </div>
      </SheetContent>
    </Sheet>
  );
}
